import { render, staticRenderFns } from "./IconSvgTeacher.vue?vue&type=template&id=b57e3014&scoped=true&"
import script from "./IconSvgTeacher.vue?vue&type=script&lang=js&"
export * from "./IconSvgTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57e3014",
  null
  
)

export default component.exports